import React from "react";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import "./_style.scss";
import { ITkModalPropsWithTitle } from "../../../type/componentsType/TkModalForSearch";
import TkButton from "../TkButton";

/**
 * モーダル部品
 * TkModalコンポーネントは、MUIのModalコンポーネントを拡張したものです。
 * @param {TkModalProps} props - TkModalPropsコンポーネントのプロパティ
 * @param {boolean} props.open trueの場合、モーダルを開く。falseの場合、モーダルを閉じる
 * @returns TkModal モーダル部品
 */
export const TkModalWithTitle: React.FC<ITkModalPropsWithTitle> = (props) => {
  const {
    open,
    onChange,
    children,
    title,
    onSave,
    onClose,
    saveData,
    clearSaveData,
    className,
    saveButtonName = "選択",
    cancelButtonName = "戻る",
    useTopButton = false,
    saveButtonDisabled = false,
    cancelButtonDisabled = false,
    showSaveButton = true,
    ...rest
  } = props;

  const handleSave = () => {
    onSave && onSave(saveData);
    clearSaveData && clearSaveData();
  };

  const handleClose = () => {
    onClose && onClose();
    clearSaveData && clearSaveData();
  };

  const ButtonGroup = () => {
    return (
      <Box className="button">
        {showSaveButton && (
          <TkButton
            disabled={saveButtonDisabled}
            onClick={handleSave}
            data-testid="TkModalWithTitleSentaku"
          >
            {saveButtonName}
          </TkButton>
        )}
        <TkButton
          disabled={cancelButtonDisabled}
          onClick={handleClose}
          data-testid="TkModalWithTitleModoru"
        >
          {cancelButtonName}
        </TkButton>
      </Box>
    );
  };

  return (
    <Modal
      open={open || false}
      onChange={onChange}
      onClose={handleClose}
      {...rest}
    >
      <Box className={`tkModalWithTitle ${className}`}>
        <Box className="titleSection">
          <Box className="title">{title}</Box>
          {useTopButton && <ButtonGroup />}
        </Box>
        <Box className="section">{children}</Box>
        {!useTopButton && (
          <Box className="button">
            <ButtonGroup />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default TkModalWithTitle;
